export const INITIAL_STATE = {
  openChatbot: false,
  showChatbot: false,
  showGlobally: false,
  showOnParticularPage: false,
  particularPageInternalVar: false,
  getChatbotResponseLoading: false,
  getChatbotResponseSuccess: null,
  getChatbotResponseFailure: null,
};
